import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import AppRoutes from './Routes';
import EnvIndicator from './components/shared/EnvIndicator';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <EnvIndicator />
        <AppRoutes />
        {/* Global Toast Notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#fff',
              color: '#333',
              border: '1px solid #e5e7eb',
              padding: '12px 16px',
              borderRadius: '8px',
            },
            success: {
              iconTheme: {
                primary: '#10B981', // Tailwind emerald-500
                secondary: '#fff',
              },
            },
            error: {
              style: {
                background: '#fee2e2',
                color: '#b91c1c',
                border: '1px solid #fca5a5',
              },
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;



